"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotReady = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var FileUpload_1 = require("../../FileUpload");
var Wrapper_1 = require("./Wrapper");
var Icon = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: 48px;\n  height: 48px;\n"], ["\n  position: relative;\n  width: 48px;\n  height: 48px;\n"])));
var NotReady = function (_a) {
    var _b = _a.error, error = _b === void 0 ? false : _b;
    return (react_1.default.createElement(Wrapper_1.Wrapper, { disabled: false, error: error, padding: '19px 27px' },
        react_1.default.createElement(Icon, null,
            react_1.default.createElement(FileUpload_1.Loading, null))));
};
exports.NotReady = NotReady;
var templateObject_1;
